import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { toast } from 'react-toastify';
import { SelectDropdown } from '../SelectDropdown';

export const ForecastEditModal = ({
    isOpen,
    onClose,
    labelItem,
    periodItem,
    onAccept
}) => {
    const [label, setLabel] = useState(labelItem || '');
    const [selectedPeriod, setSelectedPeriod] = useState("");

    useEffect(() => {
        if (!isOpen) return;
        if (labelItem) {
            setLabel(labelItem);
        }
        if (periodItem) {
            setSelectedPeriod(periodItem);
        }
    }, [isOpen]);

    const handleAcceptActions = async () => {
        if (!label && !selectedPeriod) {
            toast.error(`Empty forecast options.`, { position: "bottom-right" });
            return;
        }
        await onAccept({
            name: label,
            period: selectedPeriod,
        });
    }

    const handleClose = () => {
        onClose();
        setLabel('');
    };

    // Handle Esc key press
    useEffect(() => {
        const handleEscKey = (event) => {
            if (event.key === 'Escape' && isOpen) {
                handleClose();
            }
        };
        if (isOpen) {
            document.addEventListener('keydown', handleEscKey);
        }
        return () => {
            document.removeEventListener('keydown', handleEscKey);
        };
    }, [isOpen]);

    if (!isOpen) return null;

    const modalContent = (
        <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex min-h-screen items-end justify-center px-4 pt-4 pb-20 text-center sm:block sm:p-0">
                <div 
                    className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" 
                    aria-hidden="true"
                    onClick={handleClose}
                ></div>
                <span className="hidden sm:inline-block sm:h-screen sm:align-middle" aria-hidden="true">&#8203;</span>
                <div 
                    className="inline-block transform rounded-lg bg-white text-left align-bottom shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:align-middle"
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                        <h3 className="text-lg font-bold mb-2">Forecast</h3>
                        <div className="flex flex-col gap-1 mb-2">
                            <span>Name:</span>
                            <div className="flex-1">
                                <input
                                    type="text"
                                    value={label}
                                    onChange={(e) => {
                                        setLabel(e.target.value)
                                    }}
                                    className="w-full p-2.5 shadow-sm border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                />
                            </div>
                         </div>
                        <div className="flex flex-col gap-1 mb-2">
                            <span>Period:</span>
                            <div className="flex-1">
                                <SelectDropdown
                                    options={[
                                        { label: "2025", value: "2025" }, 
                                        { label: "2026", value: "2026" },
                                        { label: "2027", value: "2027" },
                                        { label: "2028", value: "2028" },
                                        { label: "2029", value: "2029" },
                                        { label: "2030", value: "2030" },
                                    ]}
                                    value={selectedPeriod}
                                    onChange={setSelectedPeriod}
                                    placeholder=""
                                    selectClassname="bg-white"
                                />
                            </div>
                         </div>
                         <div className="py-3 sm:flex sm:flex-row-reverse">
                                <button
                                    type="button"
                                    className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                                    onClick={handleAcceptActions}
                                >
                                    Accept
                                </button>
                                <button
                                    type="button"
                                    className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                         </div>
                    </div>
                </div>
            </div>
        </div>
    );

    return createPortal(modalContent, document.body);
};